module.exports = __webpack_public_path__ + "static/media/first_2.3a9a74e5.jpg";